const translations = {
    'deposit.gold': 'gold deposit',
    'deposit.iron': 'iron deposit',
    'deposit.stone': 'stone deposit',
};

export default translations;
